/**
 * @fileoverview PhoneInputRenderer.module.css
 * Styles for the PhoneInputRenderer component that displays a phone input field.
 *
 * @example
 * // Basic usage with the PhoneInputRenderer component
 * import css from './PhoneInputRenderer.module.css'
 *
 * <div className={css.container}>
 *   <input className={css.input} type="tel" placeholder="Phone Number" />
 *   <div className={css.flag}>+1</div>
 * </div>
 */

@import './InputRenderer.module.css';

.container {
    display: flex;
    align-items: center;
}

.input {
    flex: 1;
    border-radius: 0 1rem 1rem 0;
}

.flag {
    border: 1px solid var(--neutural400);
    border-right: none;
    border-radius: 1rem 0 0 1rem;
    padding: 1rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
}

.error {
    outline: 6px solid var(--red300);
    border: 1px solid var(--neutural900);
    border-radius: 1rem;
}

.error .input {
    border-top: 0;
    border-bottom: 0;
    border-right: 0;
}

.error .flag {
    border: 0;
}
